<div class="sub-tabs ms-5">
    <button type="button" *ngFor="let tab of subTabs" [class.active]="activeSubTab === tab.id"
        (click)="selectSubTab(tab.id)">{{ tab.labelKey | translate }}</button>
</div>

@if (activeSubTab === 'Events') {
<div class="subpage-container">
    <div class="container g-0 m-0">
        <div class="d-flex align-items-center ps-5 pb-3 pt-2">
            <app-sort class="pe-2" (close)="onEventsSortOption($event)"></app-sort>
            <div class="datepicker-container-wrapper position-relative">
                <div class="button-wrapper">
                    <div class="button">
                        <img alt="Date" src="assets/core/table-button/date.svg" />
                        <div class="button-text" (click)="toggleEventsDatepicker()"
                            [ngClass]="{ changed: eventsStartDate && eventsEndDate }">
                            <ng-container *ngIf="eventsStartDate && eventsEndDate; else noEventsDateSelected">
                                {{ eventsSelectedDate }}
                            </ng-container>
                            <ng-template #noEventsDateSelected>
                                <span class="nonselected-date">{{ "SELECTDATE" | translate }}</span>
                            </ng-template>
                        </div>
                        <img *ngIf="eventsStartDate && eventsEndDate" alt="Exit" src="assets/device/x.svg"
                            (click)="clearEventsDates()" />
                    </div>
                </div>
                @if (isEventsDatepickerOpen) {
                <div class="overlay" (click)="toggleEventsDatepicker()"></div>
                <app-datepicker [scale]="1.1" [range]="true" (dateRangeChanged)="onEventsDateRangeChanged($event)"
                    [inputFromDate]="eventsStartDate" [inputToDate]="eventsEndDate"></app-datepicker>
                }
            </div>
        </div>
        <div class="row g-0 m-0">
            <table>
                <thead>
                    <tr>
                        <th></th>
                        <th><span>{{ "EVENT_TYPE" | translate }}</span></th>
                        <th><span>{{ "READTIME" | translate }}</span></th>
                        <th><span>{{ "INGESTIONTIME" | translate }}</span></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of events">
                        <td appIsNew [executedTime]="row.ingestionTime"></td>
                        <td>
                            <span class="label-box" [ngStyle]="{ 'background-color': getAlertColor(row.channelId || '') }">
                                {{ row.channelId }}
                            </span>
                        </td>
                        <td><span>{{ row.readOnMeterTime | date: 'dd MMMM yyyy hh:mm a' }}</span></td>
                        <td><span>{{ row.ingestionTime | date: 'dd MMMM yyyy hh:mm a' }}</span></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="container-down">
        <app-pagination [lastPageSize]="eventsLastPageSize" [numberOfDevices]="numberOfEvents"
            [pageSize]="eventsPageSize" [currentPage]="eventsCurrentPage"
            (pageChange)="eventsPageChange($event)"></app-pagination>
    </div>
</div>
}

@if (activeSubTab === 'Alarms') {
<div class="subpage-container">
    <div class="container g-0 m-0">
        <div class="d-flex align-items-center ps-5 pb-3 pt-2">
            <app-sort class="pe-2" (close)="onAlarmsSortOption($event)"></app-sort>
            <div class="datepicker-container-wrapper position-relative">
                <div class="button-wrapper">
                    <div class="button">
                        <img alt="Date" src="assets/core/table-button/date.svg" />
                        <div class="button-text" (click)="toggleAlarmsDatepicker()"
                            [ngClass]="{ changed: alarmsStartDate && alarmsEndDate }">
                            <ng-container *ngIf="alarmsStartDate && alarmsEndDate; else noAlarmsDateSelected">
                                {{ alarmsSelectedDate }}
                            </ng-container>
                            <ng-template #noAlarmsDateSelected>
                                <span class="nonselected-date">{{ "SELECTDATE" | translate }}</span>
                            </ng-template>
                        </div>
                        <img *ngIf="alarmsStartDate && alarmsEndDate" alt="Exit" src="assets/device/x.svg"
                            (click)="clearAlarmsDates()" />
                    </div>
                </div>
                @if (isAlarmsDatepickerOpen) {
                <div class="overlay" (click)="toggleAlarmsDatepicker()"></div>
                <app-datepicker [scale]="1.1" [range]="true" (dateRangeChanged)="onAlarmsDateRangeChanged($event)"
                    [inputFromDate]="alarmsStartDate" [inputToDate]="alarmsEndDate"></app-datepicker>
                }
            </div>
        </div>
        <div class="row g-0 m-0">
            <table class="wide-table">
                <thead>
                    <tr>
                        <th></th>
                        <th><span>{{ "ALARM_NAME" | translate }}</span></th>
                        <th><span>{{ "STARTTIME" | translate }}</span></th>
                        <th><span>{{ "ENDTIME" | translate }}</span></th>
                        <th><span>{{ "DURATION" | translate }}</span></th>
                        <th><span>{{ "STARTINGESTIONTIME" | translate }}</span></th>
                        <th><span>{{ "ENDINGESTIONTIME" | translate }}</span></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of alarms">
                        <td appIsNew [executedTime]="row.startSavedOnTime!"></td>
                        <td>
                            <span class="label-box" [ngStyle]="{
                                'background-color': getAlertColor(row.alarmType),
                                'text-decoration': (row.endEventId || row.endCommandId) ? 'line-through' : 'none'
                            }">
                                {{ row.alarmType }}
                            </span>
                        </td>
                        <td>
                            <span class="d-flex align-items-center gap-2">
                                {{ row.startTime | date: 'dd MMMM yyyy hh:mm a' }}
                                <i class="bi bi-box-arrow-up-right" style="color: var(--green-button); font-size: 12px;"></i>
                            </span>
                        </td>
                        <td>
                            <span class="d-flex align-items-center gap-2">
                                {{ row.endTime ? (row.endTime | date: 'dd MMMM yyyy hh:mm a') : '/' }}
                                @if (row.endTime) {
                                <i class="bi bi-box-arrow-up-right" style="color: var(--green-button); font-size: 12px;"></i>
                                }
                            </span>
                        </td>
                        <td class="col-duration">
                            @if (row.startTime && row.endTime) {
                            <span class="duration-badge">
                                <i class="bi bi-clock" style="font-size: 11px;"></i>
                                {{ getDuration(row.startTime, row.endTime) }}
                            </span>
                            } @else {
                            <span>/</span>
                            }
                        </td>
                        <td><span>{{ row.startSavedOnTime | date: 'dd MMMM yyyy hh:mm a' }}</span></td>
                        <td>
                            <span>{{ row.endSavedOnTime ? (row.endSavedOnTime | date: 'dd MMMM yyyy hh:mm a') : '/' }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="container-down">
        <app-pagination [lastPageSize]="alarmsLastPageSize" [numberOfDevices]="numberOfAlarms"
            [pageSize]="alarmsPageSize" [currentPage]="alarmsCurrentPage"
            (pageChange)="alarmsPageChange($event)"></app-pagination>
    </div>
</div>
}
